import React from 'react';
import Slider from 'react-slick';
import QuoteCard from './quoteCard';
import { PaccProfileResultVO } from '@domain/vo/phs/pacc/competence/PaccProfileResultVO';
import { competenceProfileMap } from '@domain/constant/competenceType';
import classNames from 'classnames/bind';
import styles from './competencyQuotes.module.scss';

const cx = classNames.bind(styles);

const settings = {
  dots: true,
  centerMode: true,
  infinite: false,
  centerPadding: '60px',
  speed: 500,
};

interface CompetencyQuotesProps {
  paccProfileResult: PaccProfileResultVO;
}

const CompetencyQuotes = ({ paccProfileResult }: CompetencyQuotesProps) => {
  const { quotes, name } = competenceProfileMap[paccProfileResult.type];

  return (
    <div className={cx('quotesArea')}>
      <div className={cx('quotesWrap')}>
        <Slider {...settings}>
          {quotes.map((value, index) => (
            <QuoteCard key={index} {...value} />
          ))}
        </Slider>
        <div className={cx('commentWrap')}>
          <div className={cx('comment')}>대표적인 {name} 인물의 말말말!</div>
        </div>
      </div>
    </div>
  );
};

export default CompetencyQuotes;
